import { defineMessages } from "react-intl";
const messages = defineMessages({
    schedule: {
        id: "app.scanCompleted.table.schedule.placeholder",
        defaultMessage: "Schedule",
    },
    submitSchedule: {
        id: "app.scanCompleted.table.schedule.submit",
        defaultMessage: "Submit",
    },
    scheduleScannerDateLabel: {
        id: "app.scanCompleted.table.schedule.date.label",
        defaultMessage: "Add Date",
    },
    scheduleScannerDatePlaceholder: {
        id: "app.scanCompleted.table.schedule.placeholder",
        defaultMessage: "mm/dd/yy",
    },
    scheduleEmailError: {
        id: "app.scanCompleted.table.schedule.email.error",
        defaultMessage: "Invalid Email.",
    },
    scheduleInputError: {
        id: "app.scanCompleted.table.schedule.error",
        defaultMessage: "Invalid Date. Input in the mm/dd/yy format",
    },
    scheduleInputRequired: {
        id: "app.scanCompleted.table.schedule.required",
        defaultMessage: "Date is required",
    },
    scheduleScannerTimeWindowLabel: {
        id: "app.scanCompleted.table.schedule.timeWindow.label",
        defaultMessage: "Add Time Window",
    },
    scheduleScannerEmailLabel: {
        id: "app.scanCompleted.table.schedule.scannerEmail.label",
        defaultMessage: "Scanner's Email",
    },
    scheduleScannerEmailPlaceholder: {
        id: "app.scanCompleted.table.schedule.scannerEmail.placeholder",
        defaultMessage: "Select or Type a Scanner's Email",
    },
    scheduledConfirm: {
        id: "app.scanRequests.schedule.confirm",
        defaultMessage: "Scan Request of spaces {space} scheduled",
    },
    scheduleSelectScanRequestsTitle: {
        id: "app.scanRequests.schedule.selectScanRequestsTitle",
        defaultMessage: "Date & Time Window Selector",
    },
    scheduleSelectScanRequestsWarning: {
        id: "app.scanRequests.schedule.selectScanRequestsWarning",
        defaultMessage: "Select the Scan Requests to schedule.",
    },
});
export default messages;
